<template>
  <div class="video-player-container">
    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane label="实时预览" name="preview">
        <!-- 预览标签页内容为空，视频显示在下方容器中 -->
      </el-tab-pane>

      <el-tab-pane label="录像回放" name="playback">
        <!-- <div class="video-controls">
          <el-select
            v-model="recordSource"
            placeholder="请选择录像源"
            @change="handleSourceChange"
          >
            <el-option label="设备录像" :value="2"></el-option>
            <el-option label="中心录像" :value="3"></el-option>
          </el-select>
          <el-date-picker
            v-model="playbackDate"
            type="date"
            placeholder="选择日期"
            @change="handleDateChange"
          >
          </el-date-picker>
        </div> -->
      </el-tab-pane>
    </el-tabs>

    <div class="video-container">
      <div
        id="dhplayer-dom"
        style="width: 100%; min-height: 400px; border: 1px solid #ddd"
      ></div>
      
      <!-- 简单的加载状态指示器 -->
      <div v-if="loading" class="loading-overlay">
        <i class="el-icon-loading"></i>
        <span>加载中...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DHCamera",
  props: ["deviceInfo"],
  data() {
    return {
      config: {
        host: '143.3.200.2',
        port: '443',
        username: 'wg',
        password: '123456',
      },
      activeTab: "preview",
      videoPlayer: null,
      recordSource: 2,
      playbackDate: new Date(),
      channelId: '1000108$1$0$2',
      loading: false,
      retryCount: 0,
      maxRetries: 3
    };
  },

  mounted() {
    // 从设备信息中获取通道ID
    if (this.deviceInfo && this.deviceInfo.note) {
      this.channelId = this.deviceInfo.note;
    }
    // 初始化播放器
    this.initPlayer();
  },

  methods: {
    initPlayer() {
      this.loading = true;
      
      // 如果已存在播放器实例，先销毁
      if (this.videoPlayer) {
        try {
          this.videoPlayer.destroy();
          this.videoPlayer = null;
        } catch (e) {
          console.error("销毁原播放器失败:", e);
        }
      }
      
      // 创建新的播放器实例
      this.videoPlayer = new window.VideoPlayer({
        videoId: "dhplayer-dom",
        windowType: this.activeTab === "preview" ? 0 : 3, // 0表示预览，3表示回放
        usePluginLogin: true,
        pluginLoginInfo: this.config,
        division: 1,
        showBar: true,

        createSuccess: () => {
          this.$message.success("播放器初始化成功");
          this.loading = false;
          this.retryCount = 0;
          
          // 根据当前标签页开始相应的播放
          if (this.activeTab === "preview") {
            setTimeout(() => {
              this.startPreview();
            }, 1000);
          } else {
            setTimeout(() => {
              this.startPlayback();
            }, 1000);
          }
        },

        createError: (err) => {
          this.loading = false;
          this.$message.error("播放器初始化失败：" + (err.message || "未知错误"));
          
          // 添加重试逻辑
          if (this.retryCount < this.maxRetries) {
            this.retryCount++;
            this.$message.info(`正在尝试重新连接(${this.retryCount}/${this.maxRetries})...`);
            setTimeout(() => {
              this.initPlayer();
            }, 2000);
          }
        },
      });
    },

    startPreview() {
      if (!this.videoPlayer) {
        this.$message.error("播放器未初始化");
        return;
      }
      
      if (!this.channelId) {
        this.$message.error("未找到摄像头通道ID");
        return;
      }
      
      this.loading = true;
      this.videoPlayer.startReal([
        {
          channelId: this.channelId,
          trackID: 702,
          channelName: this.deviceInfo?.name || "监控通道",
          snum: 0, // 即将要播放的窗口序号，从0开始 【必传】
          streamType: 1, // 默认子码流，可以根据需要修改为0(主码流)
          deviceType: 5, // 设备类型
          cameraType: '1', // 摄像头类型 (用于云台)
          capability: '00000000000000000000000000000001', // 能力集 (用于云台)
        },
      ], {
        success: () => {
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.$message.error("开始预览失败：" + (err.message || "未知错误"));
        }
      });
    },

    startPlayback() {
      if (!this.videoPlayer || !this.channelId) {
        this.$message.error("播放器未初始化或通道ID为空");
        return;
      }
      
      const date = this.formatDate(this.playbackDate);
      this.loading = true;
      
      this.videoPlayer.startPlayback([
        {
          channelId: this.channelId,
          trackID: 702,
          channelName: this.deviceInfo?.name || "回放通道",
          startTime: `${date} 00:00:00`,
          endTime: `${date} 23:59:59`,
          recordSource: this.recordSource,
          streamType: 0, // 回放通常使用主码流以获得更好的画质
          snum: 0,
        },
      ], {
        success: () => {
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.$message.error("开始回放失败：" + (err.message || "未知错误"));
        }
      });
    },

    handleTabChange() {
      // 切换标签页时重新初始化播放器
      this.initPlayer();
    },

    // handleSourceChange() {
    //   if (this.activeTab === "playback") {
    //     this.startPlayback();
    //   }
    // },

    // handleDateChange() {
    //   if (this.activeTab === "playback") {
    //     this.startPlayback();
    //   }
    // },

    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },

  beforeDestroy() {
    // 组件销毁前清理资源
    if (this.videoPlayer) {
      try {
        this.videoPlayer.destroy();
        this.videoPlayer = null;
      } catch (e) {
        console.error("销毁播放器失败:", e);
      }
    }
  },
};
</script>

<style scoped>
.video-player-container {
  padding: 20px;
}

.video-controls {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.video-container {
  margin-top: 20px;
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.loading-overlay i {
  font-size: 32px;
  margin-bottom: 10px;
}
</style>